/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetTransportTypesResponse } from '../../entities/v1/GetTransportTypesResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1TransportTypeModelSchema } from './transportTypeModelSchema'
import { z } from 'zod'

export const v1GetTransportTypesResponseSchema = z.object({
  transport_types: z.array(z.lazy(() => v1TransportTypeModelSchema)),
}) as unknown as ToZod<V1GetTransportTypesResponse>